import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import storageSession from "redux-persist/lib/storage/session";

//reducers
import persistedRedu from "./slices/persisted/persistedSlice";
import accountRedu from "./slices/account/accountSlice";
import agendaCompromissoFiscalRedu from "./slices/agendaCompromissoFiscal/agendaCompromissoFiscalSlice";
import empresaRedu from "./slices/empresa/empresaSlice";
import configuracoesRedu from "./slices/configuracoes/configuracoesSlice";
import bancoRedu from "./slices/banco/bancoSlice";
import contaBancoRedu from "./slices/contaBanco/contaBancoSlice";
import saldoInicioContaBancoRedu from "./slices/saldoInicioContaBanco/saldoInicioContaBancoSlice";
import feriadoRedu from "./slices/feriado/feriadoSlice";
import pessoaRedu from "./slices/pessoa/pessoaSlice";
import contatoPessoaRedu from "./slices/contatoPessoa/contatoPessoaSlice";
import localizacaoRedu from "./slices/localizacao/localizacaoSlice";
import gradePremiacaoRedu from "./slices/gradePremiacao/gradePremiacaoSlice";
import sorteioRedu from "./slices/sorteio/sorteioSlice";
import condicaoGeralSorteioRedu from "./slices/condicaoGeralSorteio/condicaoGeralSorteioSlice";
import contaFinanceiraRedu from "./slices/contaFinanceira/contaFinanceiraSlice";
import tipoDocumentoRedu from "./slices/tipoDocumento/tipoDocumentoSlice";
import planoContaFinanceiroRedu from "./slices/planoContaFinanceiro/planoContaFinanceiroSlice";
import consignatarioRedu from "./slices/consignatario/consignatarioSlice";
import comparativoResultadoRedu from "./slices/comparativoResultado/comparativoResultadoSlice";
import rateioCentroCustoRedu from "./slices/rateioCentroCusto/rateioCentroCustoSlice";
import centroCustoRedu from "./slices/centroCusto/centroCustoSlice";
import formaPagamentoRecebimentoRedu from "./slices/formaPagamentoRecebimento/formaPagamentoRecebimentoSlice";
import planoContaContabilRedu from "./slices/planoContaContabil/planoContaContabilSlice";
import contaRecorrenteRedu from "./slices/contaRecorrente/contaRecorrenteSlice";
import tipoTaxaImpostoRedu from "./slices/tipoTaxaImposto/tipoTaxaImpostoSlice";
import configuracaoImpostoAdicionalRedu from "./slices/configuracaoImpostoAdicional/configuracaoImpostoAdicionalSlice";
import taxaImpostoRedu from "./slices/taxaImposto/taxaImpostoSlice";
import fechamentoFinanceiroRedu from "./slices/fechamentoFinanceiro/fechamentoFinanceiroSlice";
import perfilTaxaImpostoRedu from "./slices/perfilTaxaImposto/perfilTaxaImpostoSlice";
import periodicidadeRedu from "./slices/periodicidade/periodicidadeSlice";
import lancamentoBancarioRedu from "./slices/lancamentoBancario/lancamentoBancarioSlice";
import relatorioRedu from "./slices/relatorio/relatorioSlice";
import tipoSorteioRedu from "./slices/tipoSorteio/tipoSorteioSlice";
import pagamentoContaFinanceiraRedu from "./slices/pagamentoContaFinanceira/pagamentoContaFinanceiraSlice";
import pagamentoLoteRedu from "./slices/pagamentoLote/pagamentoLoteSlice";
import arquivoAnexoRedu from "./slices/arquivoAnexo/arquivoAnexoSlice";
import grupoPlanoContaFinanceiroRedu from "./slices/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroSlice";
import importacaoVendaConsignatarioRedu from "./slices/importacaoVendaConsignatario/importacaoVendaConsignatarioSlice";
import auditoriaContaFinanceiraRedu from "./slices/auditoriaContaFinanceira/auditoriaContaFinanceiraSlice";
import resultadoSorteioRedu from "./slices/resultadoSorteio/resultadoSorteioSlice";
import lancamentoControleAporteRedu from "./slices/lancamentoControleAporte/lancamentoControleAporteSlice";
import prestacaoContaRedu from "./slices/prestacaoConta/prestacaoContaSlice";
import vendaConsignatarioRedu from "./slices/vendaConsignatario/vendaConsignatarioSlice";
import tipoLancamentoControleAporteRedu from "./slices/tipoLancamentoControleAporte/tipoLancamentoControleAporteSlice";
import configuracaoResultadoSorteioRedu from "./slices/configuracaoResultadoSorteio/configuracaoResultadoSorteioSlice";
import painelGeralRedu from "./slices/painelGeral/painelGeralSlice";
import composicaoRedu from "./slices/composicao/composicaoSlice";
import categoriaContaBancoRedu from "./slices/categoriaContaBanco/categoriaContaBancoSlice";
import categoriaEmpresaRedu from "./slices/categoriaEmpresa/categoriaEmpresaSlice";
import planoContaResultadoRedu from "./slices/planoContaResultado/planoContaResultadoSlice";
import lancamentoConsignatarioRedu from "./slices/lancamentoConsignatario/lancamentoConsignatarioSlice";
import notasFiscaisRedu from "./slices/notasfiscais/notasFiscaisSlice";
import configuracaoImportacaoVendaRedu from "./slices/configuracaoImportacaoVenda/configuracaoImportacaoVendaSlice";
import detalheConfiguracaoImportacaoVendaRedu from "./slices/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaSlice";
import grupoContaBancoRedu from "./slices/grupoContaBanco/grupoContaBancoSlice";
import agrupamentoContaBancoRedu from "./slices/agrupamentoContaBanco/agrupamentoContaBancoSlice";

const persistedConfig = {
  key: "persisted",
  storage: storageSession,
};

const persistedReducer = persistReducer(persistedConfig, persistedRedu);

export interface RootState {
  configuracoes: ReturnType<typeof configuracoesRedu>;
  persisted: ReturnType<typeof persistedRedu>;
  account: ReturnType<typeof accountRedu>;
  agendaCompromissoFiscal: ReturnType<typeof agendaCompromissoFiscalRedu>;
  empresa: ReturnType<typeof empresaRedu>;
  feriado: ReturnType<typeof feriadoRedu>;
  banco: ReturnType<typeof bancoRedu>;
  contaBanco: ReturnType<typeof contaBancoRedu>;
  saldoInicioContaBanco: ReturnType<typeof saldoInicioContaBancoRedu>;
  pessoa: ReturnType<typeof pessoaRedu>;
  contatoPessoa: ReturnType<typeof contatoPessoaRedu>;
  localizacao: ReturnType<typeof localizacaoRedu>;
  condicaoGeralSorteio: ReturnType<typeof condicaoGeralSorteioRedu>;
  gradePremiacao: ReturnType<typeof gradePremiacaoRedu>;
  sorteio: ReturnType<typeof sorteioRedu>;
  contaFinanceira: ReturnType<typeof contaFinanceiraRedu>;
  tipoDocumento: ReturnType<typeof tipoDocumentoRedu>;
  planoContaFinanceiro: ReturnType<typeof planoContaFinanceiroRedu>;
  consignatario: ReturnType<typeof consignatarioRedu>;
  comparativoResultado: ReturnType<typeof comparativoResultadoRedu>;
  rateioCentroCusto: ReturnType<typeof rateioCentroCustoRedu>;
  centroCusto: ReturnType<typeof centroCustoRedu>;
  formaPagamentoRecebimento: ReturnType<typeof formaPagamentoRecebimentoRedu>;
  planoContaContabil: ReturnType<typeof planoContaContabilRedu>;
  fechamentoFinanceiro: ReturnType<typeof fechamentoFinanceiroRedu>;
  contaRecorrente: ReturnType<typeof contaRecorrenteRedu>;
  tipoTaxaImposto: ReturnType<typeof tipoTaxaImpostoRedu>;
  configuracaoImpostoAdicional: ReturnType<typeof configuracaoImpostoAdicionalRedu>;
  taxaImposto: ReturnType<typeof taxaImpostoRedu>;
  perfilTaxaImposto: ReturnType<typeof perfilTaxaImpostoRedu>;
  periodicidade: ReturnType<typeof periodicidadeRedu>;
  lancamentoBancario: ReturnType<typeof lancamentoBancarioRedu>;
  relatorio: ReturnType<typeof relatorioRedu>;
  tipoSorteio: ReturnType<typeof tipoSorteioRedu>;
  pagamentoContaFinanceira: ReturnType<typeof pagamentoContaFinanceiraRedu>;
  pagamentoLote: ReturnType<typeof pagamentoLoteRedu>;
  arquivoAnexo: ReturnType<typeof arquivoAnexoRedu>;
  grupoPlanoContaFinanceiro: ReturnType<typeof grupoPlanoContaFinanceiroRedu>;
  importacaoVendaConsignatario: ReturnType<typeof importacaoVendaConsignatarioRedu>;
  auditoriaContaFinanceira: ReturnType<typeof auditoriaContaFinanceiraRedu>;
  resultadoSorteio: ReturnType<typeof resultadoSorteioRedu>;
  lancamentoControleAporte: ReturnType<typeof lancamentoControleAporteRedu>;
  prestacaoConta: ReturnType<typeof prestacaoContaRedu>;
  vendaConsignatario: ReturnType<typeof vendaConsignatarioRedu>;
  tipoLancamentoControleAporte: ReturnType<typeof tipoLancamentoControleAporteRedu>;
  configuracaoResultadoSorteio: ReturnType<typeof configuracaoResultadoSorteioRedu>;
  painelGeral: ReturnType<typeof painelGeralRedu>;
  composicao: ReturnType<typeof composicaoRedu>;
  categoriaContaBanco: ReturnType<typeof categoriaContaBancoRedu>;
  categoriaEmpresa: ReturnType<typeof categoriaEmpresaRedu>;
  planoContaResultado: ReturnType<typeof planoContaResultadoRedu>;
  lancamentoConsignatario: ReturnType<typeof lancamentoConsignatarioRedu>;
  notasFiscais: ReturnType<typeof notasFiscaisRedu>;
  configuracaoImportacaoVenda: ReturnType<typeof configuracaoImportacaoVendaRedu>;
  detalheConfiguracaoImportacaoVenda: ReturnType<typeof detalheConfiguracaoImportacaoVendaRedu>;
  grupoContaBanco: ReturnType<typeof grupoContaBancoRedu>;
  agrupamentoContaBanco: ReturnType<typeof agrupamentoContaBancoRedu>;
}

const rootReducer = combineReducers({
  configuracoes: configuracoesRedu,
  persisted: persistedReducer,
  account: accountRedu,
  agendaCompromissoFiscal: agendaCompromissoFiscalRedu,
  empresa: empresaRedu,
  feriado: feriadoRedu,
  banco: bancoRedu,
  contaBanco: contaBancoRedu,
  saldoInicioContaBanco: saldoInicioContaBancoRedu,
  pessoa: pessoaRedu,
  contatoPessoa: contatoPessoaRedu,
  localizacao: localizacaoRedu,
  condicaoGeralSorteio: condicaoGeralSorteioRedu,
  gradePremiacao: gradePremiacaoRedu,
  sorteio: sorteioRedu,
  contaFinanceira: contaFinanceiraRedu,
  tipoDocumento: tipoDocumentoRedu,
  planoContaFinanceiro: planoContaFinanceiroRedu,
  consignatario: consignatarioRedu,
  comparativoResultado: comparativoResultadoRedu,
  rateioCentroCusto: rateioCentroCustoRedu,
  centroCusto: centroCustoRedu,
  formaPagamentoRecebimento: formaPagamentoRecebimentoRedu,
  planoContaContabil: planoContaContabilRedu,
  fechamentoFinanceiro: fechamentoFinanceiroRedu,
  contaRecorrente: contaRecorrenteRedu,
  tipoTaxaImposto: tipoTaxaImpostoRedu,
  configuracaoImpostoAdicional: configuracaoImpostoAdicionalRedu,
  taxaImposto: taxaImpostoRedu,
  perfilTaxaImposto: perfilTaxaImpostoRedu,
  periodicidade: periodicidadeRedu,
  lancamentoBancario: lancamentoBancarioRedu,
  relatorio: relatorioRedu,
  tipoSorteio: tipoSorteioRedu,
  pagamentoContaFinanceira: pagamentoContaFinanceiraRedu,
  pagamentoLote: pagamentoLoteRedu,
  arquivoAnexo: arquivoAnexoRedu,
  grupoPlanoContaFinanceiro: grupoPlanoContaFinanceiroRedu,
  importacaoVendaConsignatario: importacaoVendaConsignatarioRedu,
  auditoriaContaFinanceira: auditoriaContaFinanceiraRedu,
  resultadoSorteio: resultadoSorteioRedu,
  lancamentoControleAporte: lancamentoControleAporteRedu,
  prestacaoConta: prestacaoContaRedu,
  vendaConsignatario: vendaConsignatarioRedu,
  tipoLancamentoControleAporte: tipoLancamentoControleAporteRedu,
  configuracaoResultadoSorteio: configuracaoResultadoSorteioRedu,
  painelGeral: painelGeralRedu,
  composicao: composicaoRedu,
  categoriaContaBanco: categoriaContaBancoRedu,
  categoriaEmpresa: categoriaEmpresaRedu,
  planoContaResultado: planoContaResultadoRedu,
  lancamentoConsignatario: lancamentoConsignatarioRedu,
  notasFiscais: notasFiscaisRedu,
  configuracaoImportacaoVenda: configuracaoImportacaoVendaRedu,
  detalheConfiguracaoImportacaoVenda: detalheConfiguracaoImportacaoVendaRedu,
  grupoContaBanco: grupoContaBancoRedu,
  agrupamentoContaBanco: agrupamentoContaBancoRedu,
});

export default rootReducer;
